import { Card, Button, Space, Typography } from 'antd';
import { EnvironmentOutlined, BankOutlined } from '@ant-design/icons';
import { StatusBadge } from '@/components/base';
import { primary } from '@/theme';

const { Text } = Typography;

interface SectorCardProps {
  id: string;
  label: string;
  address?: string;
  rangeKm: number;
  societyName: string;
  societyType: string;
  isSelected: boolean;
  onSelect: () => void;
  onCenterMap: () => void;
  onViewSociety: () => void;
}

export function SectorCard({
  label,
  address,
  rangeKm,
  societyName,
  societyType,
  isSelected,
  onSelect,
  onCenterMap,
  onViewSociety,
}: SectorCardProps) {
  return (
    <Card
      hoverable
      onClick={onSelect}
      style={{
        width: 250,
        borderColor: isSelected ? primary[400] : undefined,
        borderWidth: isSelected ? 2 : 1,
        borderRadius: 12,
      }}
      size="small"
    >
      <Space direction="vertical" size={4} style={{ width: '100%' }}>
        <Text strong>{label}</Text>
        {address && <Text type="secondary">{address}</Text>}
        <Text type="secondary">Rayon: {rangeKm} km</Text>
        <Space>
          <BankOutlined />
          <Text>{societyName}</Text>
          <StatusBadge status={societyType} />
        </Space>
        <Space style={{ marginTop: 8 }}>
          <Button size="small" icon={<EnvironmentOutlined />} onClick={(e) => { e.stopPropagation(); onCenterMap(); }}>
            GPS
          </Button>
          <Button size="small" type="link" onClick={(e) => { e.stopPropagation(); onViewSociety(); }}>
            Voir l'entreprise
          </Button>
        </Space>
      </Space>
    </Card>
  );
}
